import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles({
  tabAtivo: {
    textAlign: 'center',  
    color: '#ff8033',
    height: 30,
    fontSize: 8
  },

  tabInativo: {
    textAlign: 'center', 
    color: '#4d4d4d',
    height: 30,
    fontSize: 8
  },
});

export default styles;